import React from 'react';
import ogImage from '../img/pixels-and-print-1200x630.jpg';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import { Helmet } from "react-helmet";


// This is the query that Apollo Client will send to the WP site.
const SITEINFO = gql`
{
	generalSettings {
		description
		title
		url
	}
}
`;

function SEO() {
	const { loading, error, data } = useQuery(SITEINFO);

	if (loading) return 'Loading...';
	if (error) return `Error! ${error.message}`;

	const { description, title, url } = data.generalSettings;

	return (
		<Helmet defaultTitle={title}>
			<html lang="en" amp />
			<meta charSet="utf-8" />
			<title itemProp="name" lang="en">{title}</title>
			<base target="_blank" href={url} />
			<link rel="canonical" href={url} />
			<meta name="description" content={description} />
			<meta name="og:description" content={description} />
			<meta property="og:type" content="website" />
			<meta property="og:image" content={ogImage} />
		</Helmet>)
}
export default SEO;
